export type LobbyPrimaryTab = 'lobby' | 'mygames';

const TABS: Array<{ id: LobbyPrimaryTab; label: string }> = [
  { id: 'lobby', label: 'Lobby' },
  { id: 'mygames', label: 'My Games' },
];

export interface LobbyPrimaryTabsProps {
  active: LobbyPrimaryTab;
  onSelect: (tab: LobbyPrimaryTab) => void;
}

/**
 * Top-level Lobby / My Games switch.
 *
 * Rendered above the content of both views rather than inside either, so switching reads as a
 * tab change on one screen — My Games used to be a separate screen reached by a floating
 * button, which gave it a back arrow and no way to see it was part of the lobby at all.
 */
export default function LobbyPrimaryTabs({ active, onSelect }: LobbyPrimaryTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Lobby sections"
      className="mb-4 grid grid-cols-2 border-b border-white/10"
    >
      {TABS.map(tab => {
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onSelect(tab.id)}
            className={[
              'relative -mb-px border-b-2 px-2 pb-3 pt-1 text-base font-semibold transition',
              isActive
                ? 'border-[#53d337] text-white'
                : 'border-transparent text-gray-400 hover:text-white',
            ].join(' ')}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
